import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// FOR ROUTING
// WHEN WE ROUTE TO A NEW PAGE, MAKE SURE WE ARE AT THE TOP OF THAT PAGE

export default function useScrollToTop(): null {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
